import { defineMessage } from 'react-intl'
import { queryKeyFilters } from 'constants/url'
import { isEmpty } from 'lib/array/arrayUtils'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { slugify } from 'lib/string/stringUtils'

export default function isAnyFilterApplied(params: Record<string, any> = {}): boolean {
  return !isEmpty(params) && queryKeyFilters.some(filterKey => !isEmpty(params[filterKey]))
}

interface CountObjectToFilterItemsOptions {
  slugStrategy?: 'preserve-label' | 'slugify'
}

export function countObjectToFilterItems(record: Record<string, { count: number }>, options?: CountObjectToFilterItemsOptions): Array<App.FilterItem> {
  return Object.entries(record).map(([label, { count }]) => ({
    slug: options?.slugStrategy === 'preserve-label' ? label : slugify(label),
    label,
    count,
  }))
}

const PAYMENT_OPTION_LABELS = {
  pay_at_property: defineMessage({
    id: 'wsraWhd3Ov41Vw9oaHyP',
    defaultMessage: 'Pay at property',
    description: 'Payment filter option for rates settled directly with the accommodation provider',
  }),
}

export function mapPaymentOptionLabel(item: App.FilterItem): App.FilterItem {
  const message = PAYMENT_OPTION_LABELS[item.slug as keyof typeof PAYMENT_OPTION_LABELS]
  return message ? { ...item, label: getCurrentIntl().formatMessage(message) } : item
}
